<template>
  <!-- Продолжительность разговоров -->
  <v-container fluid>
    <!-- Фильтры -->
    <v-card>
      <v-card-title>
        Продолжительность разговоров
      </v-card-title>

      <v-card-text>
        <v-form ref="form" lazy-validation >
          <ReportFilters
            v-model="filters"
            :searchRow="false"
          />

          <v-row>
            <v-col cols="12" sm="12" md="4" lg="12" align="right" class="mt-auto">

              <v-tooltip bottom max-width="400">
                <template #activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="info"
                    class="mr-2"
                    :disabled="mailLoading"
                    @click="submitMail"
                  >
                    <v-progress-circular
                      v-if="mailLoading"
                      indeterminate
                      color="white"
                    />
                    <v-icon v-else>mdi-mail</v-icon>
                  </v-btn>
                </template>
                <span>Послать результат на почту</span>
              </v-tooltip>

              <v-tooltip bottom max-width="400">
                <template #activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="info"
                    class="mr-2"
                    :disabled="excelLoading"
                    @click="submitExcel"
                  >
                    <v-progress-circular
                      v-if="excelLoading"
                      indeterminate
                      color="white"
                    />
                    <v-icon v-else>mdi-microsoft-excel</v-icon>
                  </v-btn>
                </template>
                <span>Скачать excel файл</span>
              </v-tooltip>

              <v-btn color="success" @click="submitForm">Поиск</v-btn>

            </v-col>
          </v-row>
        </v-form>

      </v-card-text>
    </v-card>

    <!-- Таблица -->
    <v-card class="mt-5">
      <v-data-table
        :headers="headers"
        :items="report"
        :items-per-page="-1"
        :loading="reportLoading"
        item-key="uid"
        loading-text="Загрузка..."
        no-data-text="Ничего не найдено"
        hide-default-footer
        dense
      >
        <template #[`item.agent`]="{ item }">
          [{{item.sip}}] {{item.agent}}
        </template>
      </v-data-table>
    </v-card>



  </v-container>

</template>

<script>
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'
import ReportFilters from '~/components/pages/stat/elements/ReportFilters.vue'

export default {
  name: 'DurationTalkByOperators',
  components: {
    ReportFilters,
  },

  data() {
    return {
      filters: {},

      mailLoading: false,
      excelLoading: false,
      reportLoading: false,

      report: [],
      headers: [
        {
          text: 'Оператор',
          value: 'agent',
          sortable: true,
          caption: null,
          sort: (a, b) => {
            let item1 = this.report.find(item => item.agent === a)
            let item2 = this.report.find(item => item.agent === b)
            
            let sip1 = Number(item1.sip)
            let sip2 = Number(item2.sip)

            return sip1 - sip2
          }
        },
        {
          text: 'Проект',
          value: 'project',
          sortable: true,
          caption: null,
        },
        {
          text: 'Время разговора на проекте',
          value: 'duration_by_project',
          sortable: true,
          caption: null,
        },
        {
          text: 'Время разговора всего',
          value: 'duration_total',
          sortable: true,
          caption: null,
        },
      ],
    }
  },

  computed: {
    ...mapGetters({
    }),

    payload() {
      let payload = {
        mail: false,
        excel: false,
      }

      for (const key in this.filters) {
        let val = this.filters[key]
        if (Array.isArray(val) && val.length === 0) continue
        if (val) payload[key] = val
      }

      if (this.filters.period) {
        payload.period = [
          moment(this.filters.period.start).format('YYYY-MM-DD HH:mm:ss'),
          moment(this.filters.period.end).format('YYYY-MM-DD HH:mm:ss'),
        ]
      }

      return payload
    },
  },

  methods: {
    ...mapActions({
      loadDurationReport: 'duration_talk/loadDurationReport'
    }),

    async submitMail() {
      try {
        this.mailLoading = true
        let payload = window.structuredClone(this.payload)
        payload.mail = true
        await this.loadDurationReport(payload)
      } catch (error) {
        console.log(error)
      } finally {
        this.mailLoading = false
      }
    },

    async submitExcel() {
      try {
        this.excelLoading = true
        let payload = window.structuredClone(this.payload)
        payload.excel = true
        await this.loadDurationReport(payload)
      } catch (error) {
        console.log(error)
      } finally {
        this.excelLoading = false
      }
    },

    async submitForm() {
      try {
        this.reportLoading = true
        this.report = await this.loadDurationReport(this.payload)
      } catch (error) {
        this.report = []
        console.log(error)
      } finally {
        this.reportLoading = false
      }
    },
  },

  mounted() {},
}
</script>

<style scoped></style>




